import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import i18n from "../../../translate/i18n.jsx";

import colesterol from "../../../assets/colesterol.png";
import coracao from "../../../assets/coracao.png";
import imunidade from "../../../assets/imunidade.png";
import pele from "../../../assets/pele.png";

export default function Beneficio() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const lang = i18n.language;
  const castanhaSlug = i18n.getFixedT(lang)("endereco.castanha");

  const irParaBeneficiosDaCastanha = () => {
    navigate(`/${lang}/${castanhaSlug}#cajuCultura-section`);
  };

  return (
    <section id="beneficio">
      <h1>{t("home.beneficio.titulo")}</h1>
      <div className="beneficio-container">
        <div className="beneficio-lista">
          <div className="beneficio-item">
            <img src={colesterol} className="icone" alt="Colesterol" />
            <h2>{t("home.beneficio.topicos.t1.titulo")}</h2>
            <p>{t("home.beneficio.topicos.t1.descricao")}</p>
          </div>
          <div className="beneficio-item">
            <img src={imunidade} className="icone" alt="Imunidade" />
            <h2>{t("home.beneficio.topicos.t2.titulo")}</h2>
            <p>{t("home.beneficio.topicos.t2.descricao")}</p>
          </div>
          <div className="beneficio-item">
            <img src={coracao} className="icone" alt="Coração" />
            <h2>{t("home.beneficio.topicos.t3.titulo")}</h2>
            <p>{t("home.beneficio.topicos.t3.descricao")}</p>
          </div>
          <div className="beneficio-item">
            <img src={pele} className="icone" alt="Pele" />
            <h2>{t("home.beneficio.topicos.t4.titulo")}</h2>
            <p>{t("home.beneficio.topicos.t4.descricao")}</p>
          </div>
        </div>

        <div className="beneficio-cta">
          <p>{t("home.beneficio.botao.pergunta")}</p>
          <button
            className="botao-beneficio"
            onClick={irParaBeneficiosDaCastanha}
          >
            {t("home.beneficio.botao.botao")}
          </button>
        </div>
      </div>
    </section>
  );
}
